<script>

// import PlayerSettingsMixin from './PlayerSettingsMixin.vue'

import Tracking from '../components/tracking/Tracking.vue'

export default {

    // mixins: [PlayerSettingsMixin],

    components: {
        Tracking
    },

    data() {
        return {
            ready: false,
            error: false,
            errorMsg: 'Unbekannter Fehler',
        }
    },

    // computed: {
    //     preroll() {
    //         return this.$videoAdSchedule.preroll
    //     },
    //     postroll() {
    //         return this.$videoAdSchedule.postroll
    //     },
    //     midroll() {
    //         return this.$videoAdSchedule.midroll
    //     },
    //     adSchedule() {
    //         return this.$videoAdSchedule.adSchedule
    //     },
    //     adScheduleOptions() {
    //         return this.$videoAdSchedule.options
    //     }
    // },

    events: {
        jwReady() {
            this.ready = true
        },

        jwSetupError(evt) {
            this.error = true
        },

        jwError(evt) {
            this.error = true
        },

        jwMeta(evt) {
            if(evt.duration || evt.height || evt.width) {
                this.$manager.addItemData({
                    duration: evt.duration,
                    height: evt.height,
                    width: evt.width,
                })
            }
        }

    }

}
</script>



// WEBPACK FOOTER //
// src/mixins/PlayerMixin.vue